import React, { useState } from "react";
import Esop from "../../assets/thumbnail.png";
import PerksIcon1 from "../../assets/perksBenefitsIcon1.png";
import PerksIcon2 from "../../assets/perksBenefitsIcon2.png";
import PerksIcon3 from "../../assets/perksBenefitsIcon3.png";
import "./PerksBenefits.scss";
const PerksBenefits = () => {
	const [videoIsOn, setVideoIsOn] = useState(false);

	const clickHandler = () => {
		setVideoIsOn(true);
	};
	return (
		<div>
			<div className='Esop'>
				<h3 className='Esop__heading'>
					Clan members pouring out their emotions on the <br />
					announcement of 1st buyback
				</h3>
				<div className='Esop__image' onClick={clickHandler}>
					{videoIsOn ? (
						<video
							style={{ objectFit: "cover", width: "100%", height: "100%" }}
							autoPlay={videoIsOn}
							controls
							loop
						>
							<source src='https://storage.googleapis.com/cp-prod-assets-public-as-sth1-gcs-w37fpj/careers/buyback.mp4' />
						</video>
					) : (
						<img src={Esop} alt='esop' />
					)}
				</div>
				<p className='Esop__text'>
					We recently announced our first ESOP buyback worth $1M with an option
					to liquidate 100% holdings
				</p>
			</div>

			<div className='PerksBenefits'>
				<h4 className='PerksBenefits__heading'>Perks & Benefits</h4>
				<p className='PerksBenefits__quote'>
					We live by the philosophy of, “With the team, for the team”.
				</p>
				<div className='PerksBenefits__items'>
					<div className='PerksBenefits__item'>
						<img src={PerksIcon1} alt='PerksIcon1' />
						<h4>Super-Cool Team</h4>
						<p>
							Great folks to work with | Timely reviews and feedbacks |
							Accelerated growth | Excellent learning opportunities
						</p>
					</div>
					<div className='PerksBenefits__item'>
						<img src={PerksIcon2} alt='PerksIcon2' />
						<h4>Personal Growth</h4>
						<p>
							Classplus upskilling and wellness programs ensure accelerated
							personal growth and wholesome mental and physical care of clan
							members
						</p>
					</div>
					<div className='PerksBenefits__item'>
						<img src={PerksIcon3} alt='PerksIcon3' />
						<h4>Wealth Creation</h4>
						<p>
							All our members get a chance to share the sweet-sweet pie through
							ESOPs and Referral ESOPs
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PerksBenefits;
